import LocationSelector from "../Common/LocationSelector.jsx";
import tmaxLogo from "../../Assets/CurrentWeather/tmaxLogo.svg";
import tminLogo from "../../Assets/CurrentWeather/tminLogo.svg";
import humidityLogo from "../../Assets/CurrentWeather/humidityLogo.svg";
import rainfallLogo from "../../Assets/CurrentWeather/rainfallLogo.svg";
import solarWindLogo from "../../Assets/CurrentWeather/solarWindLogo.svg";

import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logoAndTitleFunction from "../../AllFunctions/logoAndTitleFunction";
import { Tooltip } from "react-tooltip";
import { setIsCelsius } from "../../ReduxStore/App/DashBoard/dashboardSlice";

function DefaultWeather() {
  const {
    currentDayWithTime,
    placeName,
    isCelsius,
    formattedWeather
  } = useSelector((store) => store.dashboard);

  const dispatch = useDispatch();

  const basicParameters = [
    {
      title: "Rainfall",
      mapName: "Rainfall",
      sign: "mm",
      logo: rainfallLogo,
    },
    {
      title: "Tmin",
      mapName: "Tmin",
      sign: "°C",
      logo: tminLogo,
    },
    {
      title: "Tmax",
      mapName: "Tmax",
      sign: "°C",
      logo: tmaxLogo,
    },
    {
      title: "Humidity",
      mapName: "RH",
      sign: "%",
      logo: humidityLogo,
    },
    {
      title: "Wind-speed",
      mapName: "Wind_Speed",
      sign: "(m/s)",
      logo: solarWindLogo,
    },
  ];

  const todayStr = new Date().toISOString().split("T")[0];
  const todayWeather = formattedWeather?.find(item =>
    item.Date_time?.startsWith(todayStr)
  );
  const weatherToShow = todayWeather || formattedWeather?.[0];
  return (
    <div
      className={`flex flex-col  border-3 text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold    bg-primaryBgColor dark:bg-darkModePrimaryBgColor   lg:px-4 sm:px-2 py-2 rounded-md justify-around  h-full`}
    >
      {/* ========first part=======================    */}
      <div className="lg:flex justify-between text-blackPrimaryText dark:text-darkModeBlackPrimaryText   items-center    ">
        <div className="sm:flex sm:justify-center sm:gap-2 lg:flex lg:flex-col lg:gap-0   font-semibold sm:mb-1 lg:mb-0">
          <p>{currentDayWithTime.time}</p>
          <p>{currentDayWithTime.date}</p>
        </div>
        <LocationSelector />
      </div>
      {/* ========first part=======================    */}

      {weatherToShow ? (
        <div className="lg:grid lg:grid-cols-7 text-blackPrimaryText dark:text-darkModeBlackPrimaryText  sm:flex sm:flex-col sm:gap-1 lg:gap-0   ">
          {/* =============middle comp with two Components=================== */}
          <div className="flex flex-col justify-around lg:col-span-5    h-full     ">
            {/* ======middle comp=========== */}
            <div className="flex justify-between items-center mb-4   h-1/2 ">
              <div>
                <p className="flex sm:text-[50px] lg:text-[64px] font-semibold ">
                  {!isCelsius
                    ? ` ${Math.trunc(weatherToShow?.Tavg || 0)} °C`
                    : ` ${Math.trunc(
                      (weatherToShow?.Tavg || 0) * (9 / 5) + 32
                    )} °F`}
                </p>

                <p className="-mt-4 font-semibold">
                  {logoAndTitleFunction(weatherToShow)?.title}
                </p>
              </div>
              <div>
                <img
                  className=" lg:w-[100px]  "
                  width={""}
                  src={logoAndTitleFunction(weatherToShow)?.logo || ''}
                  alt=""
                />
              </div>
            </div>



            {/* ======middle comp=========== */}

            <div className="md:grid md:grid-cols-5 lg:grid lg:grid-cols-5 lg:gap-2 sm:h-full   md:justify-between md:h-1/2  sm:grid sm:grid-cols-3 sm:gap-2  sm:col-span-2 col-end-3  ">
              {basicParameters?.map((currentPara, index) => (
                <div
                  className="flex flex-col bg-cardBgColor dark:bg-darkModeCardBgColor border border-gray-200 dark:border-white/10 rounded-lg text-blackPrimaryText dark:text-darkModeBlackPrimaryText justify-around items-center h-full sm:py-2 hover:shadow-md transition-all duration-300"
                  key={index}
                >
                  <img width={"24px"} src={currentPara.logo} alt="" />

                  <p className="text-[16px] font-semibold">
                    {`${(weatherToShow?.[currentPara.mapName] || 0).toFixed(2)}${currentPara.sign
                      }`}
                  </p>
                  <p className="text-[14px] font-semibold">
                    {currentPara.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* =============middle comp with two Components=================== */}
          {/* Custom Temperature Toggle */}
          <div className="lg:flex lg:flex-col lg:justify-between lg:items-end lg:col-span-2 sm:flex sm:justify-center">
            <div
              onClick={() => dispatch(setIsCelsius(!isCelsius))}
              className="relative flex items-center bg-cardBgColor dark:bg-black/20 rounded-full p-1 cursor-pointer w-24 border-4 border-gray-200 dark:border-white/20 shadow-inner group transition-all"
            >
              {/* Sliding Background */}
              <div
                className={`absolute w-10 h-8 bg-wsText dark:bg-white dark:bg-opacity-20 rounded-full transition-all duration-300 shadow-md ${!isCelsius ? "translate-x-0" : "translate-x-11"
                  }`}
              />

              {/* Labels */}
              <div className="flex w-full justify-between items-center z-10 font-extrabold text-[12px]">
                <span className={`w-10 text-center transition-colors duration-300 ${!isCelsius ? "text-white dark:text-white" : "text-blackPrimaryText dark:text-darkModeBlackPrimaryText opacity-80"}`}>
                  °C
                </span>
                <span className={`w-10 text-center transition-colors duration-300 ${isCelsius ? "text-white dark:text-white" : "text-blackPrimaryText dark:text-darkModeBlackPrimaryText opacity-80"}`}>
                  °F
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold">
              Weather Data Not Available
            </p>
          </div>
        </div>
      )}
      <Tooltip id="my-tooltip" />
    </div>
  );
}

export default DefaultWeather;
